export default {
  members: [
    {
      name: '伍涛',
      urllink: '',
      imgUrl: require('../../static/img/member/member_1.jpg'),
      brief: '2016年9月加入TGO鲲鹏会（当时称作EGO），先后加入TGO上海7组和新4组，2018年加入TGO上海理事会，2019年担任TGO上海会长。担任TGO面试官期间，近20位申请者经伍涛面试后加入TGO。',
      company: '游族',
      profile: 'CTO'
    },
    {
      name: '陆栋栋',
      urllink: '',
      imgUrl: require('../../static/img/member/member_2.jpg'),
      brief: '2015年12月加入TGO鲲鹏会（当时称作EGO），参加新会员培训后加入TGO上海4组，并在2019年GTLC全球技术领导力峰会进行主题分享。',
      company: '喜马拉雅',
      profile: 'CTO'
    },
    {
      name: '丁宁',
      urllink: '',
      imgUrl: require('../../static/img/member/member_3.jpg'),
      brief: '2016年3月加入TGO鲲鹏会（当时称作EGO），是TGO广州分会的创始会员之一，历任小组组长、学习委员等岗位，同时担任TGO新会员面试官。',
      company: '荔枝',
      profile: 'CTO'
    },
    {
      name: '胡哲人',
      urllink: '',
      imgUrl: require('../../static/img/member/member_4.jpg'),
      brief: '2016年10月加入TGO鲲鹏会（当时称作EGO），参加新会员培训后加入TGO上海8组；在2017年GTLC全球技术领导力峰会进行主题分享；2019年加入TGO上海理事会，并担任TGO新会员面试官。',
      company: '流利说',
      profile: 'CTO'
    },
    {
      name: '郭炜',
      urllink: '',
      imgUrl: require('../../static/img/member/member_5.jpg'),
      brief: '2017年3月加入TGO鲲鹏会（当时称作EGO），参加新会员培训后加入TGO北京12组并担任组长至今；2018年加入TGO北京理事会并担任会长，同时担任TGO新会员面试官。',
      company: '易观',
      profile: 'CTO'
    },
    {
      name: '黄东旭',
      urllink: '',
      imgUrl: require('../../static/img/member/member_6.jpg'),
      brief: '2016年11月加入TGO鲲鹏会（当时称作EGO），参加新会员培训后加入TGO北京11组，2019年担任11组组长至今。东旭联合创立的公司PingCAP现有4位TGO会员。',
      company: 'PingCAP/TiDB',
      profile: 'CTO'
    },
    {
      name: '韩卿',
      urllink: '',
      imgUrl: require('../../static/img/member/member_7.jpg'),
      brief: '2015年9月加入TGO鲲鹏会（当时称作EGO），是TGO上海分会的创始会员之一，加入TGO上海一组；一直通过参加活动和积极分享等支持TGO。',
      company: 'Kyligence',
      profile: 'CEO'
    },
    {
      name: '杨冀龙',
      urllink: '',
      imgUrl: require('../../static/img/member/member_8.jpg'),
      brief: '2017年1月加入TGO鲲鹏会（当时称作EGO），参加新会员培训后加入TGO北京11组并担任组长；2018年加入TGO北京理事会并担任小组委员，2019年出任服务委员。',
      company: '知道创宇',
      profile: 'CTO'
    },
    {
      name: '洪小军',
      urllink: '6',
      imgUrl: require('../../static/img/member/member_9.jpg'),
      brief: '2019年1月加入TGO鲲鹏会，是TGO厦门分会的创始会员之一，同时是TGO厦门首任会长；参加新会员培训后加入TGO厦门1组；2019年因工作变动加入深圳分会，并担任TGO深圳学习委员。',
      company: 'Aftership',
      profile: 'CTO'
    },
    {
      name: '杨攀',
      urllink: '2',
      imgUrl: require('../../static/img/member/member_10.jpg'),
      brief: '2017年2月加入TGO鲲鹏会（当时称作EGO），参加新会员培训后加入TGO北京13组，2018年担任组长至今；2018年加入TGO北京理事会并担任小组委员，2019年出任学习委员。杨攀担任TGO会员面试官期间，面试申请者超过20位。',
      company: '融云',
      profile: '联合创始人兼CTO'
    }
  ]
}
